"use strict";

require("./home.service.js");

angular.module("customer")
.controller("SectionHome", function(
    $scope, $rootScope, $q, HomeService, Language, ModalService, UserService, RetailerUserInfoService, common,
    PromotionCatalogEntryService
) {
    Language.initializeScope($scope, "language", "locale");
    $scope.hasPromotions = false;
    $scope.carouselService = PromotionCatalogEntryService;
    $scope.banners = [];
    $scope.carouselItems = [];
    $scope.activeCarouselIndex = 0;

    function getCarouselItems(language) {
        var imagePath = 'image_path_' + language.toLowerCase();
        $scope.carouselItems = [];
        $scope.activeCarouselIndex = 0;

        for (var i = 0; i < $scope.banners.length; i++) {
            var carouselItem = $scope.banners[i];
            if (carouselItem[imagePath] !== undefined && carouselItem[imagePath].mobile !== undefined) {
                $scope.carouselItems.push(carouselItem);
            }
        }
    }

    $scope.$on("LanguageChanged", function(obj, locale, short_code) {
        getCarouselItems(short_code);
    });

    $scope.isCommunityCarouselPresent = false;

    $scope.$on("isCommunityCarouselPresent", function(event, value) {
        $scope.isCommunityCarouselPresent = value;
    });

    HomeService.getBanners().$promise.then(function(data) {
        $scope.banners = data;
        getCarouselItems(Language.getLanguage())
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/home/home.controller.js
// module id = 890
// module chunks = 0